import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import CommentsHeader from '../../preview/Sections/Comments/CommentsHeader';

const Header = props => {
    const toggleComments = () => {
        props.commentsStore.root.ui.toggle('comments');
    };

    return <div className='sidebar-header'>
        <span
            className='icon icon-close'
            onClick={toggleComments}
            data-what='comments-btn'
            data-which='close-panel'
        />
        <CommentsHeader {...props}/>
    </div>;
};

export default observer(Header);

Header.propTypes = {
    commentsStore: PropTypes.object.isRequired
};
